import { Button } from "@material-ui/core";
import React, { useEffect } from "react";

export default function ExportRuleLayers({
  data = [],
  drawingName = "",
  modelName = "",
}) {
  useEffect(() => {
    if (modelName) {
      console.log(drawingName, modelName);
    }
  }, [modelName]);

  const flattenLayerDependencies = (layerObj) => {
    // List all possible keys you want in every output object
    const allKeys = [
      "layerId",
      "drawingId",
      "layerName",
      "alwaysOn",
      "removeForDxf",
      "isCompareFullName",
      "alwaysOff",
      "disabled",
      "isDelete",
      "isAdd",
      "layerRuleId",
      "dependencyId",
      "dependencyLayerRuleId",
      "ddName",
      "minValue",
      "maxValue",
      "layerRule",
    ];

    // Helper to create a default object with all keys as empty string
    function createDefaultObject() {
      return allKeys.reduce((acc, key) => {
        acc[key] = "";
        return acc;
      }, {});
    }

    // Helper to fill values from sources into the default object
    function fillObject(sourceList) {
      const obj = createDefaultObject();
      for (const src of sourceList) {
        for (const key of Object.keys(src)) {
          if (
            allKeys.includes(key) &&
            src[key] !== undefined &&
            src[key] !== null
          ) {
            obj[key] = src[key];
          }
        }
      }
      return obj;
    }

    // If no layerRules, return just the base info
    if (
      !Array.isArray(layerObj.layerRules) ||
      layerObj.layerRules.length === 0
    ) {
      return [fillObject([layerObj])];
    }

    // Flatten dependencies if present
    let result = [];
    for (const rule of layerObj.layerRules) {
      if (
        Array.isArray(rule.layerDependencies) &&
        rule.layerDependencies.length > 0
      ) {
        for (const dep of rule.layerDependencies) {
          result.push(
            fillObject([
              layerObj,
              { layerRuleId: rule.layerRuleId },
              {
                dependencyId: dep.id,
                dependencyLayerRuleId: dep.layerRuleId,
                ddName: dep.ddName,
                minValue: dep.minValue,
                maxValue: dep.maxValue,
                layerRule: dep.layerRule,
              },
            ])
          );
        }
      } else {
        // If no dependencies in this rule, return the info up to rule level
        result.push(fillObject([layerObj, { layerRuleId: rule.layerRuleId }]));
      }
    }

    return result;
  };

  const downloadJsonAsCsvWithOrAndEmptyRows = (
    jsonArray,
    filename = "data.csv"
  ) => {
    // Define the columns and their display names
    const columns = [
      "layerName",
      "alwaysOn",
      "alwaysOff",
      "isCompareFullName",
      "removeForDxf",
      "ddName",
      "minValue",
      "maxValue",
    ];
    const columnDisplayNames = {
      layerName: "Layer Name",
      alwaysOn: "Always On",
      alwaysOff: "Always Off",
      isCompareFullName: "Compare Full Name",
      removeForDxf: "Remove For Dxf",
      ddName: "DD Name",
      minValue: "Min Value",
      maxValue: "Max Value",
    };

    // Create the CSV header row using display names
    const csvRows = [`Model,${modelName},Drawing,${drawingName}`];

    csvRows.push(
      columns.map((col) => columnDisplayNames[col] || col).join(",")
    );

    for (let i = 0; i < jsonArray.length; i++) {
      const obj = jsonArray[i];
      const prevObj = i > 0 ? jsonArray[i - 1] : null;

      // Insert empty row when layerId changes (excluding the first row)
      // if (i > 0 && obj.layerId !== prevObj.layerId) {
      //   csvRows.push(columns.map(() => "").join(","));
      // }

      // Insert "OR" row if needed
      if (
        i > 0 &&
        obj.layerId === prevObj.layerId &&
        obj.layerRuleId !== prevObj.layerRuleId
      ) {
        const orRow = columns
          .map((col) => (col === "ddName" ? "OR" : "-"))
          .join(",");
        csvRows.push(orRow);
      }

      // Build the normal row
      const row = columns
        .map((col) => {
          let value = obj[col];
          if (col === "layerName" && typeof value === "string")
            value = value.trim();
          if (value === undefined || value === null) value = "";
          if (
            typeof value === "string" &&
            (value.includes(",") || value.includes('"') || value.includes("\n"))
          ) {
            value = `"${value.replace(/"/g, '""')}"`;
          }
          return value;
        })
        .join(",");
      csvRows.push(row);
    }

    const csvString = csvRows.join("\n");
    const blob = new Blob([csvString], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const formatAll = () => {
    const flattenedData = [];
    data.forEach((ele) => {
      const temp = flattenLayerDependencies(ele);
      flattenedData.push(...temp);
    });
    console.log(flattenedData);
    downloadJsonAsCsvWithOrAndEmptyRows(flattenedData, "data.csv");
  };
  return (
    <div
      style={{
        width: "200px",
        marginLieft: "auto",
      }}
    >
      <Button onClick={formatAll} className="newrule">
        Export Layers
      </Button>
    </div>
  );
}
